"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var CustomPropTypes = require("../util/custom-prop-types");
var repeater_1 = require("./repeater");
var localizers_1 = require("../util/localizers");
var number_input_1 = require("../number-input");
var round_1 = require("./round");
var widget_helpers_1 = require("../util/widget-helpers");
var vdl_prefix_1 = require("../util/vdl-prefix");
var minus_1 = require("adp-react-icons/lib/fa/minus");
var plus_1 = require("adp-react-icons/lib/fa/plus");
var timeout_manager_1 = require("../util/timeout-manager");
var focus_mixin_1 = require("../mixins/focus-mixin");
var directions = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    UP: 'UP',
    DOWN: 'DOWN'
};
var format = function (props) { return localizers_1.number.getFormat('default', props.format); };
var NumberSpinner = /** @class */ (function (_super) {
    __extends(NumberSpinner, _super);
    function NumberSpinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
            active: false
        };
        _this._isMounted = false;
        _this._timeoutManager = new timeout_manager_1.TimeoutManager();
        _this.setTimeout = function (key, callback, duration) {
            if (_this._isMounted) {
                return _this._timeoutManager.setTimeout(key, callback, duration);
            }
        };
        _this.handleBlur = function (event) {
            focus_mixin_1.handleBlur(_this, event);
        };
        _this.handleFocus = function (event) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            focus_mixin_1.handleFocus(_this, event, undefined, function (focused) {
                _this.focus();
            });
        };
        // allow for styling, focus stealing keeping me from the normal what have you
        _this._mouseDown = function (dir) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            var method = dir === directions.UP
                ? _this.increment
                : _this.decrement;
            _this.setState({ active: dir });
            var val = method.call(_this);
            if (!((dir === directions.UP && val === _this.props.max)
                || (dir === directions.DOWN && val === _this.props.min))) {
                if (!_this._cancelRepeater)
                    _this._cancelRepeater = repeater_1.Repeater(_this._mouseDown.bind(null, dir));
            }
            else
                _this._mouseUp();
        };
        _this._mouseUp = function () {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            _this.setState({ active: false });
            _this._cancelRepeater && _this._cancelRepeater();
            _this._cancelRepeater = undefined;
        };
        _this._keyDown = function (e) {
            if (_this.props.disabled || _this.props.readOnly) {
                return;
            }
            var key = e.key;
            widget_helpers_1.notify(_this.props.onKeyDown, [e]);
            if (e.defaultPrevented)
                return;
            if (key === 'End' && isFinite(_this.props.max))
                _this.change(_this.props.max);
            else if (key === 'Home' && isFinite(_this.props.min))
                _this.change(_this.props.min);
            else if (key === 'ArrowDown') {
                e.preventDefault();
                _this.decrement();
            }
            else if (key === 'ArrowUp') {
                e.preventDefault();
                _this.increment();
            }
        };
        _this.focus = function () {
            ReactDOM.findDOMNode(_this._input).focus();
        };
        _this.increment = function () {
            return _this.step(_this.props.step);
        };
        _this.decrement = function () {
            return _this.step(-_this.props.step);
        };
        _this.step = function (amount) {
            var value = (_this.props.value || 0) + amount;
            var decimals = _this.props.precision != null
                ? _this.props.precision
                : localizers_1.number.precision(format(_this.props));
            _this.change(decimals != null ? round_1.round(value, decimals) : value);
            return value;
        };
        _this.change = function (val) {
            val = _this.constrainValue(val);
            if (_this.props.value !== val) {
                widget_helpers_1.notify(_this.props.onChange, val);
            }
        };
        _this.constrainValue = function (value) {
            var max = _this.props.max == null ? Infinity : _this.props.max, min = _this.props.min == null ? -Infinity : _this.props.min;
            if (value === undefined || value == null || value === '') {
                return undefined;
            }
            return Math.max(Math.min(value, max), min);
        };
        return _this;
    }
    NumberSpinner.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    NumberSpinner.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        this._timeoutManager.clearAllTimeouts();
    };
    NumberSpinner.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, onKeyPress = _a.onKeyPress, onKeyUp = _a.onKeyUp, disabled = _a.disabled, readOnly = _a.readOnly, tabIndex = _a.tabIndex;
        var messages = this.props.messages;
        var customProps = _1.omit(this.props, Object.keys(NumberSpinner.propTypes));
        var val = this.constrainValue(this.props.value);
        var numberSpinnerClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('number-spinner')] = true,
            _b[vdl_prefix_1.vdlPrefix('number-spinner--focus')] = this.state.focused,
            _b[vdl_prefix_1.vdlPrefix('number-spinner--disabled')] = disabled,
            _b[vdl_prefix_1.vdlPrefix('number-spinner--readonly')] = readOnly,
            _b);
        var numberInputClasses = [
            vdl_prefix_1.vdlPrefix('number-spinner__input')
        ];
        var decrementButtonClasses = (_c = {},
            _c[vdl_prefix_1.vdlPrefix('number-spinner__button')] = true,
            _c[vdl_prefix_1.vdlPrefix('number-spinner__button--decrement')] = true,
            _c[vdl_prefix_1.vdlPrefix('number-spinner__button--active')] = this.state.active === directions.DOWN,
            _c);
        var incrementButtonClasses = (_d = {},
            _d[vdl_prefix_1.vdlPrefix('number-spinner__button')] = true,
            _d[vdl_prefix_1.vdlPrefix('number-spinner__button--increment')] = true,
            _d[vdl_prefix_1.vdlPrefix('number-spinner__button--active')] = this.state.active === directions.UP,
            _d);
        return (React.createElement("div", __assign({}, customProps, { ref: function (c) { _this._element = c; }, onKeyDown: this._keyDown, onFocus: this.handleFocus, onBlur: this.handleBlur, tabIndex: -1, className: classnames_1.classNames(className, numberSpinnerClasses) }),
            React.createElement("button", { tabIndex: -1, type: "button", className: classnames_1.classNames(decrementButtonClasses), onMouseDown: this._mouseDown.bind(null, directions.DOWN), onMouseUp: this._mouseUp.bind(null, directions.DOWN), onMouseLeave: this._mouseUp.bind(null, directions.DOWN), onClick: this.handleFocus, disabled: val === this.props.min || this.props.disabled, "aria-disabled": val === this.props.min || this.props.disabled }, messages.decrement),
            React.createElement(number_input_1.NumberInput, { ref: function (c) { _this._input = c; }, className: classnames_1.classNames(numberInputClasses), tabIndex: disabled || readOnly ? -1 : tabIndex || 0, placeholder: this.props.placeholder, value: val, autoFocus: this.props.autoFocus, editing: this.state.focused, format: this.props.format, parse: this.props.parse, name: this.props.name, role: "spinbutton", min: this.props.min, "aria-valuenow": val, "aria-valuemin": isFinite(this.props.min) ? this.props.min : null, "aria-valuemax": isFinite(this.props.max) ? this.props.max : null, "aria-disabled": this.props.disabled, "aria-readonly": this.props.readOnly, disabled: this.props.disabled, readOnly: this.props.readOnly, onChange: this.change, onKeyPress: onKeyPress, onKeyUp: onKeyUp }),
            React.createElement("button", { tabIndex: -1, type: "button", className: classnames_1.classNames(incrementButtonClasses), onMouseDown: this._mouseDown.bind(null, directions.UP), onMouseUp: this._mouseUp.bind(null, directions.UP), onMouseLeave: this._mouseUp.bind(null, directions.UP), onClick: this.handleFocus, disabled: val === this.props.max || this.props.disabled, "aria-disabled": val === this.props.max || this.props.disabled }, messages.increment)));
        var _b, _c, _d;
    };
    NumberSpinner.propTypes = {
        // -- controlled props -----------
        value: PropTypes.number,
        onChange: PropTypes.func,
        //------------------------------------
        min: PropTypes.number,
        max: PropTypes.number,
        step: PropTypes.number,
        precision: PropTypes.number,
        culture: PropTypes.string,
        format: PropTypes.any,
        name: PropTypes.string,
        parse: PropTypes.func,
        autoFocus: PropTypes.bool,
        disabled: CustomPropTypes.disabled,
        readOnly: CustomPropTypes.readOnly,
        messages: PropTypes.shape({
            increment: PropTypes.node,
            decrement: PropTypes.node
        }),
        placeholder: PropTypes.string,
        onKeyDown: PropTypes.func,
        onKeyPress: PropTypes.func,
        onKeyUp: PropTypes.func,
        tabIndex: PropTypes.number
    };
    NumberSpinner.defaultProps = {
        min: -Infinity,
        max: Infinity,
        step: 1,
        messages: {
            increment: React.createElement(plus_1.default, null),
            decrement: React.createElement(minus_1.default, null)
        }
    };
    return NumberSpinner;
}(React.PureComponent));
exports.NumberSpinner = NumberSpinner;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/number-spinner/number-spinner.js
// module id = 575
// module chunks = 0 1 2 3 4 5 6